import { ICopperPipingRequest } from '../utils/entities/interface';
import { Pagination } from './booking';
import { get, post } from './https';

interface CopperPipingRequestsResponse {
  status: boolean;
  data: ICopperPipingRequest[];
  count: number;
  pagination: Pagination;
}

const GETCopperPipingRequests = async ({
  page = 1,
  limit = 25,
  searchQuery = '',
  sortField = '',
  sortOrder = 'DESC',
}: {
  page?: number;
  limit?: number;
  searchQuery?: string;
  sortField?: string;
  sortOrder?: 'ASC' | 'DESC';
}): Promise<CopperPipingRequestsResponse> => {
  // Initialize the base URL with COPPER_PIPING type
  let url = `/api/v1/admin/enquiry-list?limit=${limit}&page=${page}&type=COPPER_PIPING`;

  // Conditionally add search parameter if provided
  if (searchQuery) {
    url += `&search=${searchQuery}`;
  }

  // Conditionally add sortField and sortOrder if they are provided
  if (sortField && sortField !== 'name') {
    url += `&sortField=${sortField}`;
  }

  if (sortOrder && sortOrder !== 'ASC') {
    url += `&sortOrder=${sortOrder}`;
  }

  // Fetch the response
  const response = await get(url);

  if (response.status == 200) {
    return response.data; // Return the copper piping data
  } else {
    throw new Error('Failed to fetch copper piping requests');
  }
};

// Admin: single copper piping request (enquiry detail, enriched with
// user_info, technician_info and copperPipingDetails)
const GETCopperPipingRequestById = async (enquiryId: string) => {
  if (!enquiryId) {
    throw new Error('Enquiry id is required');
  }
  const response = await get(`/api/v1/admin/enquiry/${enquiryId}`);
  if (response?.status === 200 && response?.data?.status) {
    return response.data.data;
  }
  throw new Error(
    response?.data?.message || 'Failed to fetch copper piping request',
  );
};

// Admin: create a copper piping request on a customer's behalf. Uses the
// shared enquiry-creation endpoint (same one Sell Old AC uses), which
// already branches on `subType: 'COPPER_PIPING'` to also create the linked
// CopperPipingEnquiry document.
const CreateCopperPipingEnquiry = async (payload: Record<string, any>) => {
  const response = await post('/api/v1/admin/enquiry/create', payload);
  if (response.status === 201 || response.status === 200) {
    return response.data;
  }
  throw new Error(response?.data?.message || 'Failed to create request');
};

export {
  GETCopperPipingRequests,
  GETCopperPipingRequestById,
  CreateCopperPipingEnquiry,
};
